import { createContext, useContext, useState, useMemo } from 'react';

const LoadingContext = createContext({
  addRequest: () => {},
  removeRequest: () => {}
});

export const useLoading = () => useContext(LoadingContext);

const LoadingComponent = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0);

  const addRequest = () => {
    setLoadingCount(prev => prev + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top smoothly
  };
  
  const removeRequest = () => setLoadingCount(prev => Math.max(prev - 1, 0));

  const isLoading = loadingCount > 0;

  const contextValue = useMemo(() => ({ addRequest, removeRequest }), []);

  return (

    <LoadingContext.Provider value={contextValue}>
      {isLoading && <div className='loading-wrapper-maximize'><div className='loading'>Loading...</div></div>}
      <div className={isLoading ? 'content-minimize' : 'content-maximize'}>
        {children}
      </div>
    </LoadingContext.Provider>
    
  );
};

export default LoadingComponent;